module.exports = __webpack_public_path__ + "img/logo negativo.cea5436f.png";